/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.
 */

export interface MerchantBackendFeatures {
  salesFunnel: boolean;
}

/** Features that depend on a particular merchant-backend protocol version. */
export function getMerchantBackendFeatures(
  _protocolVersion?: string,
): MerchantBackendFeatures {
  return {
    // /private/statistics-report/sales-funnel is not part of the currently
    // supported merchant API. Replace this constant with a version comparison
    // once the endpoint is assigned a released protocol version.
    salesFunnel: false,
  };
}
